import { FC } from "react";
import { FullHeightContainer } from "../../Common/views/FullHeightContainer";
import { LoadingView } from "../../Common/views/LoadingView";
import { HeaderConfig } from "../../Header/views/HeaderConfig";
import { useMyMember } from "../../Members/hooks/useMyMember";
import { useMyUser } from "../../Users/hooks/useMyUser";
import { ProviderHomeOnboardingView } from "./ProviderHomeOnboardingView";
import { ProviderHomeView } from "./ProviderHomeView";

export const ProviderHomePage: FC = () => {
  const { user, isInitializing: userIsInitializing } = useMyUser();
  const { member, isInitializing: memberIsInitializing } = useMyMember();

  const isTeamMemberInvited = !!member?.tasks?.isTeamMemberInvited;
  const isProviderProfileComplete = !!member?.tasks?.isProviderProfileComplete;
  const areMemberTasksComplete =
    (isProviderProfileComplete && isTeamMemberInvited) || !member;
  const isInitializing = userIsInitializing || memberIsInitializing;

  return (
    <>
      <HeaderConfig variant="WITH_NAVIGATION" />
      {isInitializing && (
        <FullHeightContainer>
          <LoadingView />
        </FullHeightContainer>
      )}
      {!isInitializing && !areMemberTasksComplete && member && (
        <ProviderHomeOnboardingView member={member} />
      )}
      {!isInitializing && areMemberTasksComplete && user && (
        <ProviderHomeView user={user} member={member} />
      )}
    </>
  );
};
